import React from "react";
import { useButtonsActions } from "../../hooks/useButtonsActions";
import { Button } from "../Button";
import { Carousel } from "../Carousel";
import { Subtitle } from "../Subtitle";
import "./styles.scss";

interface OndeComprarProps {}

function OndeComprar({}: OndeComprarProps) {
  const { handleNavigateToPages } = useButtonsActions();

  return (
    <section id="ondeComprar">
      <div>
        <Subtitle text="Onde você quer comprar?" />
        <p>Você pode fazer as suas compras nas lojas abaixo.</p>

        <Carousel />

        <Button
          text="Ver todas as lojas indicadas"
          onClick={handleNavigateToPages}
          id="lojasIndicadasOndeComprar"
        />
      </div>
    </section>
  );
}

export { OndeComprar };
